import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex_direction: column;
  justify-content: center;
  align-items: flex-start;
  & .problems-list{
    display: inline-block;
    list-style: none;
    padding: 1rem;
    background-color: #E8E8E8;
    border-redius: 4px;
  }
  & .text-problem{
    & span{
      font-weight: bold;
    }
  }
`
